export const defaultLinkData: LinkModel = {
  url: '',
};
